import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    nombre: '',
    inactivo: false,
    rowVersion: null,
    
    canalDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, canalId) {
        state.id = canalId;
        state.nombre = '';
        state.inactivo = false;
        state.rowVersion = null;
    },
    'SET_CANAL'(state, canal) {
        state.nombre = canal.nombre.toUpperCase().trim();
        state.inactivo = (/true/i).test(canal.inactivo);
        state.rowVersion = canal.rowVersion;
    },

    'INICIALIZAR_DATOS'(state) {
        state.canalDatos = [];
    },
    'SET_DATOS'(state, datos) {
        state.canalDatos = datos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, canalId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', canalId);

            if (canalId != 0) {
                apiAxios.get(`canales/${canalId}/abm` ) 
                    .then(res => {
                        commit('SET_CANAL', res.data);
                        resolve();
                    })
                    .catch(error => reject(error))
            } else {
                resolve();
            }
        }, error => {
            reject(error);
        })
    },    
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let canal = {
                nombre: state.nombre.toUpperCase().trim(),
                inactivo: state.inactivo,
            }

            let url = 'canales';
            if (state.id != 0) {
                url += '/' + state.id;
                canal.rowVersion = state.rowVersion;
            }
            
            apiAxios.post(url, canal)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, canalId ) {
        return new Promise((resolve, reject) => {

            commit('INICIALIZAR_DATOS');
            
            if (canalId) {
                if (canalId != 0) {
                    apiAxios.get(`canales/${canalId}`) 
                    .then(res => {
                        var datos = [
                            { 'nombre': 'id', 'campo': 'Cod.', 'valor': res.data.id, 'formato': '' },
                            { 'nombre': 'nombre', 'campo': 'Nombre', 'valor': res.data.nombre, 'formato': '' },
                            { 'nombre': 'inactivo', 'campo': 'Inactivo', 'valor': (res.data.inactivo) ? 'Si' : 'No', 'formato': '' },
                        ];
                        commit('SET_DATOS', datos);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
                }
            } 
        }, error => {
            reject(error);
        })            
    },
    // inactivar ( {}, canalId ) {
    //     return new Promise((resolve, reject) => {
    //         apiAxios.post(`marcas/${canalId}/inactivar`)
    //             .then(() => resolve())
    //             .catch(error => reject(helpers.methods.getErrorMessage(error)));
    //     })
    // },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}